<template>
  <div id="goodsItem">
    <!-- 物品分类模块 -->
    <diy-table
      :model="'goodsItem'"
      :tableData="data.tableData"
      :tableMenu="data.tableMenu"
      :searchData="data.searchData"
      :searchButton="data.searchButton"
      :pageData="data.pageData"
      @showTableData="showTableData"
      @showSearchData="showSearchData"
      @showPageData="showPageData"
      @handleSearch="handleSearch"
      @handleClick="handleClick"
      @handleSelectionChange="handleSelectionChange"
    ></diy-table>

    <diy-dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.data"
      :buttonList="dialogData.buttonList"
      @showDialogData="showDialogData"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy-dialog>

    <diy-drawer
      v-if="drawerData.flag"
      :drawerData="drawerData.data"
      :title="drawerData.title"
      :buttonList="drawerData.buttonList"
      @showDrawerData="showDrawerData"
      @colseDrawer="colseDrawer"
      @handleDrawerButton="handleDrawerButton"
    ></diy-drawer>
  </div>
</template>
<script>
import * as goodsItemData from "./goodsItem.js";
import * as goodsItem from "@/api/goodsItem/goodsItem.js";
import * as CommonData from "@/api/common/common.js";
import { exportData } from "@/utils/requestPOST";
import { getAuthority } from "@/api/auth/auth.js";
import { getMenuBtn } from "@/views/menu.js";
export default {
  inject: ["reload"],
  data() {
    return {
      data: this.$base.initData("goodsItem"),
      multipleSelection: [],

      dialogData: {
        tempData: {},
        flag: false,
        title: "",
        width: "",
        data: [],
        buttonList: [],
      },

      drawerData: {
        flag: false,
        width: "20%",
        title: "",
        data: [],
        buttonList: [],
      },
      staffListData: [], //员工下拉框数据
      id: "",
    };
  },
  methods: {
    async initTableData() {
      let requestData = {
        pageSize: this.data.pageData.pageSize,
        pageNum: this.data.pageData.currentPage,
      };

      requestData = this.$total.array2json(this.data.searchData, requestData);
      let goodsItemListData = await goodsItem.listPageGoodsItem(requestData);
      this.data.tableData = goodsItemListData.records;
      this.data.pageData.total = goodsItemListData.total;
    },
    /**
     * 顶部搜索按钮点击事件
     * @param {*} key
     */
    async handleSearch(key) {
      switch (key) {
        case "search":
          // 查询
          await this.initTableData();
          break;
        case "add":
          // 新增
          this.drawerData.title = "添加物品分类信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureAddEmploy" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = goodsItemData.returnEditData();
          this.drawerData.flag = true;
          break;
        case "edit":
          // 编辑
          if (
            this.multipleSelection.length == 0 ||
            this.multipleSelection.length > 1
          ) {
            this.$message({
              message: "请选择一条数据进行编辑!",
              type: "error",
            });
            return;
          }
          this.drawerData.title = "编辑物品分类信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureUpdateEmploy" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = goodsItemData.returnEditData();
          this.drawerData.data = this.$total.json2array(
            this.drawerData.data,
            this.multipleSelection[0]
          );
          this.drawerData.flag = true;
          break;
        case "delete":
          // 删除
          if (this.multipleSelection.length == 0) {
            this.$message({
              message: "请至少选择一条数据进行删除操作!",
              type: "error",
            });
            return;
          }
          this.$confirm("此操作将永久删除所选的信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let ids = "";
              this.multipleSelection.forEach((item) => {
                ids = item.typeId + "," + ids;
              });
              let requestData = { ids: ids };
              await goodsItem.deleteGoodsItem(requestData);
              await this.initTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });

          break;
        default:
          break;
      }
    },
    /**
     * 表格按钮点击事件
     * @param {*} val
     */
    handleClick(val) {
      let row = val.row;
      let key = val.key;
    },
    /**
     * 弹出框的操作事件
     * @param {*} key
     */
    async dialogOper(key) {
      switch (key) {
        case "cancel":
          this.colseDialog();

          break;

        default:
          break;
      }
    },
    /**
     * 抽屉按钮点击事件
     * @param {*} key
     */
    async handleDrawerButton(key) {
      let requestData = {};
      let flag;
      let F;
      switch (key) {
        case "cancel":
          this.colseDrawer();
          break;
        case "sureAddEmploy":
          // 添加物品分类基础信息
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );
          requestData.userId = requestData.displayName;
          await goodsItem.addGoodsItem(requestData);
          this.$message({
            message: "物品分类信息添加成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();
          break;
        case "sureUpdateEmploy":
          // 编辑物品分类基础信息
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );
          requestData.typeId = this.multipleSelection[0].typeId;
          await goodsItem.updateGoodsItem(requestData);
          this.$message({
            message: "员工物品分类信息修改成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();
          break;

        default:
          break;
      }
    },
    /**
     * 添加或修改新闻资讯
     * @param {*} flag
     */
    async saveOrUpdateEmploy(flag) {},

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showTableData(val) {
      this.data.tableData = val;
    },
    showSearchData(val) {
      this.data.searchData = val;
    },
    showPageData(val) {
      this.data.pageData = val;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    showDialogData(val) {
      this.dialogData.data = val;
    },
    colseDrawer() {
      this.drawerData.flag = false;
    },
    showDrawerData(val) {
      this.drawerData.data = val;
    },
  },
  async mounted() {
    await this.initTableData();
  },
};
</script>
<style lang="less" scoped>
#goodsItem {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
